import { Component, Input } from '@angular/core';

export interface CollapseData {
  id: string;
  title: string;
  content: string;
}
@Component({
  selector: '[app-collapse]',
  templateUrl: './collapse.component.html',
})
export class CollapseComponent {
  @Input()
  data: CollapseData;

  @Input()
  set triggerOpen(value: boolean) {
    if (value) {
      this.active = value;
    }
  }

  active: boolean;

  onToggleItem() {
    this.active = !this.active;
  }

  get getContent(): string {
    const urlRegex = /(https?:\/\/[^\s,]+)/g;

    return this.data?.content.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank">${url}</a>`;
    });
  }
}
